const ADMIN_TOKEN_KEY = "verixxon_admin_token";
const ADMIN_PROFILE_KEY = "verixxon_admin_profile";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.verixxon.com";

export const setAdminSession = ({ token, profile }) => {
  const nextToken = String(token || "").trim();
  const nextProfile = profile || {};

  if (!nextToken) {
    return "";
  }

  localStorage.setItem(ADMIN_TOKEN_KEY, nextToken);
  localStorage.setItem(ADMIN_PROFILE_KEY, JSON.stringify(nextProfile));

  return nextToken;
};

export const registerAdmin = async ({ name, email, password }) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/auth/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: String(name || "").trim() || "Admin",
        email: String(email || "").trim().toLowerCase(),
        password: String(password || "").trim(),
      }),
    });

    const payload = await response.json();
    if (!response.ok) {
      return { ok: false, message: payload.message || "Failed to register admin." };
    }

    setAdminSession({
      token: payload.token,
      profile: {
        name: payload?.data?.name || "Admin",
        email: payload?.data?.email || String(email || "").trim().toLowerCase(),
        role: payload?.data?.role || "admin",
      },
    });

    return { ok: true, token: payload.token };
  } catch (_error) {
    return { ok: false, message: "Unable to connect to backend service." };
  }
};

export const signInAdmin = async ({ email, password }) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/auth/signin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: String(email || "").trim().toLowerCase(),
        password: String(password || "").trim(),
      }),
    });

    const payload = await response.json();
    if (!response.ok) {
      return { ok: false, message: payload.message || "Invalid admin credentials." };
    }

    setAdminSession({
      token: payload.token,
      profile: {
        name: payload?.data?.name || "Admin",
        email: payload?.data?.email || String(email || "").trim().toLowerCase(),
        role: payload?.data?.role || "admin",
      },
    });

    return { ok: true, token: payload.token };
  } catch (_error) {
    return { ok: false, message: "Unable to connect to backend service." };
  }
};

export const requestAdminPasswordReset = async ({ email }) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/auth/forgot-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: String(email || "").trim().toLowerCase(),
      }),
    });

    const payload = await response.json();
    if (!response.ok) {
      return { ok: false, message: payload.message || "Failed to send reset email." };
    }

    return {
      ok: true,
      message: payload.message || "If this admin email exists, a reset link has been sent.",
    };
  } catch (_error) {
    return { ok: false, message: "Unable to connect to backend service." };
  }
};

export const resetAdminPassword = async ({ token, email, password }) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/auth/reset-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: String(token || "").trim(),
        email: String(email || "").trim().toLowerCase(),
        password: String(password || "").trim(),
      }),
    });

    const payload = await response.json();
    if (!response.ok) {
      return { ok: false, message: payload.message || "Failed to reset password." };
    }

    return { ok: true, message: payload.message || "Password reset successful." };
  } catch (_error) {
    return { ok: false, message: "Unable to connect to backend service." };
  }
};

export const isAdminAuthenticated = () => {
  return Boolean(localStorage.getItem(ADMIN_TOKEN_KEY));
};

export const getAdminToken = () => {
  return localStorage.getItem(ADMIN_TOKEN_KEY);
};

export const getAdminProfile = () => {
  const profile = localStorage.getItem(ADMIN_PROFILE_KEY);
  return profile ? JSON.parse(profile) : null;
};

export const clearAdminSession = () => {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  localStorage.removeItem(ADMIN_PROFILE_KEY);
};
